import React, { useContext, useState } from 'react';

import { faAngleRight } from '@fortawesome/pro-regular-svg-icons/faAngleRight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton, Typography } from '@mui/material';

import { Link } from 'react-router-dom';
import { Loading } from '../../common/components/Loading';
import { Resource } from '../../common/constants/resource';
import { FeatureFlagsContext } from '../../common/featureFlagsWrapper';
import styles from '../detail/styles.module.scss';
import { TaskDetailsItem } from '../detail/tasks/components/TaskDetailsItem';
import { factsExist } from '../detail/utilities/taskDetailUtilities';
import { Evidence } from '../tasks/types/evidence';
import { TaskTypes } from '../tasks/types/taskTypes';
import { DisclosureDisplay } from './DisclosureDisplay';
import { fetchEvidenceData } from './helpers';

export const DisclosureDetail = ({
  product,
  carrier,
  policyId,
  evidenceId,
}: {
  product: string;
  carrier: string;
  policyId: string;
  evidenceId: number;
}) => {
  const { flags } = useContext(FeatureFlagsContext);
  const { isQeInterviewQaEnabled } = flags;
  const [expanded, setExpanded] = useState(false);
  const [evidence, setEvidence] = useState<Evidence | null>(null);
  const [evidenceInprogress, setEvidenceInprogress] = useState(false);
  const [evidenceReady, setEvidenceReady] = useState(false);
  const doExpand = async () => {
    if (!expanded) {
      if (!evidenceReady && !evidenceInprogress) {
        // fetch ruleResultData
        setEvidenceInprogress(true);
        const result = await fetchEvidenceData(
          product,
          carrier,
          policyId,
          evidenceId.toString(),
          TaskTypes.QE_DISCLOSURE,
        );
        setEvidence(result);
        setEvidenceReady(true);
        setEvidenceInprogress(false);
      }
    }
    setExpanded(!expanded);
  };
  return (
    <Box pt={8}>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        ml={-1}
      >
        <Box display="flex" flexDirection="row">
          <Box mt={-0.15} ml={-3.5} position="absolute">
            <IconButton
              style={{ width: '24px' }}
              size="small"
              onClick={doExpand}
            >
              <FontAwesomeIcon
                icon={faAngleRight}
                rotation={expanded ? 90 : undefined}
              />
            </IconButton>
          </Box>
          <Typography variant="h2">Disclosure</Typography>
        </Box>
      </Box>

      {expanded &&
        (evidenceInprogress ? (
          <Loading fullscreen={false} />
        ) : (
          evidenceReady &&
          (evidence ? (
            factsExist(evidence) ? (
              <>
                {isQeInterviewQaEnabled && (
                  <TaskDetailsItem
                    leftItem={Resource.TASK_DETAILS_TITLE_QE_INTERVIEW_QA}
                    rightItem={
                      <Link
                        target="_blank"
                        to={`/workbench/qna/policy/${policyId}`}
                        className={styles.Document}
                      >
                        {`application_qna_${policyId}`}
                      </Link>
                    }
                  />
                )}
                <DisclosureDisplay disclosureData={evidence} />
              </>
            ) : (
              <></>
            )
          ) : (
            <Box>
              <Typography variant="body1">
                failed to load disclosure data
              </Typography>
            </Box>
          ))
        ))}
    </Box>
  );
};
